module.exports = __webpack_public_path__ + "img/qswc.5fcc5546.png";